import React from 'react'
import { withProps, compose } from '@nobia/zeus-components/lib/recompose'
import styled, { rem } from '@nobia/zeus-components/lib/styled'
import { withTranslation } from '@nobia/zeus-components/lib/i18n'
import DropdownMagnet from './DropdownMagnet'

type SortingOption = {
  key: string,
  ascending: boolean,
  value: string,
}

const Wrapper = styled.ul`
  list-style-type: none;
  ${(props) => props.theme.media.min.md`
    > div {
      height: ${rem(40)};
      position: relative;
      z-index: 20;
    }
  `};
`

const Label = withTranslation('app.sorting')((props) => <span {...props} />)

type Props = {
  options: SortingOption[],
  select: (?SortingOption) => void,
  selected: SortingOption,
}

const SortBoxMagnet = ({ options, select, selected }: Props) => (
  <Wrapper data-cy="SortBoxMagnet">
    <DropdownMagnet
      options={options}
      selected={selected.value}
      select={(value) => {
        if (value !== 'default') {
          select(options.find((option) => option.value === value))
        }
      }}
      header={(value) => <Label intlKey={value || 'default'} />}
    >
      {(value) => <Label intlKey={value} />}
    </DropdownMagnet>
  </Wrapper>
)

export default compose(
  withProps(({ options }) => ({
    options: [
      {
        key: null,
        ascending: true,
        value: 'default',
        enabled: true,
      },
      ...options.map((option) => ({ ...option, enabled: true })),
    ],
  }))
)(SortBoxMagnet)
